module.exports = __webpack_public_path__ + "static/img/Store-6.f698448e.png";